import React from 'react';
import StoreYTVideoSection from '../../StoreHomePage/StoreYTVideoSection/StoreYTVideoSection';
import { YouTubeVideo } from './styled';

function PdpVideoSection(props) {
  const data = {
    youtubeLink: 'https://youtu.be/QIgn2Zn_fgI',
  };
  return (
    <YouTubeVideo>
      <p>Safety First: Step-by-Step Guide for New Parents</p>
      <StoreYTVideoSection homeVideo={true} data={data} />
    </YouTubeVideo>
  );
}

export default PdpVideoSection;
